import { FaHeart } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer-wrapper">
            <p>Made with  <FaHeart color="red"/> by Cristian Scarlat in Timișoara</p>
            <p>Copyright 2024 © All rights reserved</p>
        </footer>
    )
}

export default Footer;